import React from "react";
import SpinnerHandler from "../../../hoc/SpinnerHandler/SpinnerHandler";
import useHttpSection from "../../../hooks/useHttpSection";
import { Link } from "react-router-dom";
import moment from "moment-jalaali";
import "./sectionStyle.scss";

const SynopticTabs = {
  title: "ایستگاه سینوپتیک",
  chart: "Chart/Synoptic",
  values: [
    { value: "محل ایستگاه" },
    { value: "نام" },
    { value: "کد" },
    { value: "سرعت باد" },
    { value: "جهت باد" },
    { value: "رطوبت نسبی" },
    // { value: "دمای هوا" },
    { value: "بارش" },
    { value: "دمای کمینه" },
    { value: "دمای متوسط" },
    { value: "دمای بیشینه" },
  ],
  colors: [
    "#f3faf9",
    "#f9f3fa",
    "#f5f3fa",
    "#faf3f4",
    "#f4faf3",
    "#f9f3fa",
    "#f4f3fa",
    "#f3f8fa",
    "#f4f3fa",
    "#f3f8fa",
    "#f3f8fa",
  ],
  widths: [
    "200px",
    "100px",
    "80px",
    "100px",
    "100px",
    "120px",
    "120px",
    "100px",
    "100px",
    "100px",
  ],
  totalWidth: 1070,
  items: {
    name: 3,
    code: 2,
    location: 0,
    latest_update: {
      relative_humidity: 6,
      wind_speed_knots: 4,
      wind_direction_degree: 5,
      medium_temp: 7,
    },
  },
};

const SynopticSection = (props) => {
  const { data, isLoading } = useHttpSection(props);

  const handleDate = (item) => {
    if (item) {
      if (item.date) {
        return moment(item.date).format("jYYYY/jMM/jDD");
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  return (
    <SpinnerHandler isLoading={isLoading}>
      <div className="topHeaderContainer">
        <ul className="listTab">
          {SynopticTabs.values.map((e, i) => (
            <li
              style={{
                backgroundColor: SynopticTabs.colors[i],
                width: SynopticTabs.widths[i],
                fontWeight: "bolder",
                fontSize: 14,
              }}
              key={e.value}
            >
              {e.value}
            </li>
          ))}
        </ul>
        <div className="line topline">
          <div></div>
        </div>
      </div>
      {data.map((item) => (
        <div className="rowContainer" key={item.id}>
          <div key={item.id} className="synopticRowContainer">
            <div style={{ display: "flex" }}>
              <div className="item1">
                <p>{item.location}</p>
              </div>
              <div className="item2">
                <p>{item.name}</p>
              </div>
              <div className="item3">
                <p>{item.code}</p>
              </div>
              <div className="item4">
                <p>
                  {item.latest_update && item.latest_update.wind_speed_knots}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                  (item.latest_update.wind_speed_knots === 0 ||
                    item.latest_update.wind_speed_knots)
                    ? handleDate(item.latest_update)
                    : ""}
                </p>
              </div>
              <div className="item5">
                <p>
                  {item.latest_update &&
                    item.latest_update.wind_direction_degree}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                  (item.latest_update.wind_direction_degree === 0 ||
                    item.latest_update.wind_direction_degree)
                    ? handleDate(item.latest_update)
                    : ""}
                </p>
              </div>
              <div className="item6">
                <p>
                  {item.latest_update && item.latest_update.relative_humidity}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                    item.latest_update.relative_humidity &&
                    handleDate(item.latest_update)}
                </p>
              </div>
              <div className="item7">
                <p>{item.latest_update && item.latest_update.rainfall}</p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                  (item.latest_update.rainfall === 0 ||
                    item.latest_update.rainfall)
                    ? handleDate(item.latest_update)
                    : ""}
                </p>
              </div>
              <div className="item8">
                <p>
                  {item.latest_update ? item.latest_update.minimum_temp : ""}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                  (item.latest_update.minimum_temp === 0 ||
                    item.latest_update.minimum_temp)
                    ? handleDate(item.latest_update)
                    : ""}
                </p>
              </div>
              <div className="item9">
                <p>
                  {item.latest_update ? item.latest_update.medium_temp : ""}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                  (item.latest_update.medium_temp === 0 ||
                    item.latest_update.medium_temp)
                    ? handleDate(item.latest_update)
                    : ""}
                </p>
              </div>
              <div className="item10">
                <p>
                  {item.latest_update ? item.latest_update.maximum_temp : ""}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                  (item.latest_update.maximum_temp === 0 ||
                    item.latest_update.maximum_temp)
                    ? handleDate(item.latest_update)
                    : ""}
                </p>
              </div>
            </div>
            <div className="buttonBox">
              <Link
                className="link"
                to={{
                  pathname: "Chart/Synoptic",
                  state: { name:SynopticTabs.title + " " + item.name, id: item.id },
                }}
              >
                <div className="buttonFullData">اطلاعات کامل</div>
              </Link>
            </div>
          </div>
          <div className="line">
            <div></div>
          </div>
        </div>
      ))}
      {!data.length && !isLoading && (
        <div className="noItemContainer">
          <p>هیچ موردی یافت نشد</p>
        </div>
      )}
    </SpinnerHandler>
  );
};

export default SynopticSection;
